import { EnvConfig } from '~/app/utils/feature-flag'

export type FeatureFlagKey = 'newCartPage' | 'newOrderPages'

type FeatureFlags = Record<FeatureFlagKey, EnvConfig>

export const featureFlagsConfig: FeatureFlags = {
  newCartPage: {
    local: true, // true 로 해야 로컬에서 테스트 가능합니다!
    dev: true,
    qa: true,
    stage: true,
    prod: true,
  },
  newOrderPages: {
    local: true,
    dev: false,
    qa: false,
    stage: false,
    prod: false,
  },
}
